import React from 'react';
import PropTypes from 'prop-types';

const About = ({ siteMetadata }) => (
  <article>
    <h2 className="md-text-center">About</h2>
    <p className="md-text-center">{siteMetadata.description}</p>
    <p className="md-caption md-text-center">We offer full cycle software development services, starting with a raw ideas analysis and resulting in end-to-end applications fully adjusted to business needs.</p>
    <p className="md-caption md-text-center">We build our development process on the Agile principles of transparency and collaboration with our clients. We strongly believe that our clients should have a heavy hand in the product development from the very outset to the fully-functioning piece of software.</p>
    <p className="md-caption md-text-center">We enhance our clients businesses by designing, developing, implementing and maintaining highly efficient and quality software solutions.</p>
  </article>
);

About.propTypes = {
  siteMetadata: PropTypes.object
};

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js